import { useState } from "react";
import { Plus } from "lucide-react";
import { toast } from "sonner";
import { useApp } from "@/context/AppContext";
import { uuid } from "@/lib/format";
import { MONEY_KINDS, LEAVE_KINDS, KIND_TONE, daysBetween, today } from "@/lib/hr";
import { BigButton, Field, inputCls } from "@/components/ui-kit";

export default function HrEventForm({ member, mode, onSaved }) {
  const { t, dispatch } = useApp();
  const kinds = mode === "money" ? MONEY_KINDS : LEAVE_KINDS;
  const [f, setF] = useState({ kind: kinds[0], amount: "", date: today(), date_to: "", note: "" });
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const isMoney = mode === "money";
  const save = () => {
    if (isMoney && !(Number(f.amount) > 0)) return toast.error(t("hr_amount"));
    const data = { id: uuid(), staff_id: member.id, staff_name: member.name, kind: f.kind, date: f.date, note: f.note.trim(),
      amount: isMoney ? Number(f.amount) : 0, date_to: !isMoney && f.kind !== "late" ? f.date_to || f.date : "", days: isMoney || f.kind === "late" ? 0 : daysBetween(f.date, f.date_to) };
    if (dispatch("hr.event", data)) { toast.success(t("hr_event_saved")); setF({ ...f, amount: "", note: "", date_to: "" }); onSaved?.(); }
  };
  return (
    <div className="rounded border border-[#CCCCCC] bg-[#F7F7F7] p-3 space-y-3" data-testid={`hr-form-${mode}`}>
      <div className="flex flex-wrap gap-1.5">
        {kinds.map((k) => (
          <button key={k} type="button" onClick={() => setF({ ...f, kind: k })} data-testid={`hr-kind-${k}`}
            className={`h-9 px-3 rounded border text-xs font-bold transition-colors ${f.kind === k ? "text-white" : "bg-white border-[#ADADAD] text-[#333]"}`}
            style={f.kind === k ? { background: KIND_TONE[k], borderColor: KIND_TONE[k] } : undefined}>{t(`hr_kind_${k}`)}</button>
        ))}
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-2">
        {isMoney && <Field label={t("hr_amount")}><input dir="ltr" inputMode="decimal" value={f.amount} onChange={set("amount")} className={inputCls} data-testid="hr-amount-input" /></Field>}
        <Field label={t("hr_date")}><input type="date" dir="ltr" value={f.date} onChange={set("date")} className={inputCls} data-testid="hr-date-input" /></Field>
        {!isMoney && f.kind !== "late" && <Field label={t("hr_date_to")}><input type="date" dir="ltr" value={f.date_to} min={f.date} onChange={set("date_to")} className={inputCls} data-testid="hr-date-to-input" /></Field>}
        <Field label={t("hr_note")}><input value={f.note} onChange={set("note")} className={inputCls} data-testid="hr-note-input" /></Field>
        <div className="flex items-end"><BigButton onClick={save} className="w-full !h-12" data-testid="hr-save-event-btn"><Plus className="w-5 h-5" />{t("hr_add_event")}</BigButton></div>
      </div>
    </div>
  );
}
